import { QueryClient } from '@tanstack/react-query'

/**
 * The app's single query cache.
 *
 * Lives here rather than in `App.tsx` because signing in and out have to be able to
 * empty it (see `hooks/useAuth.ts`), and the auth provider is mounted *outside*
 * `QueryClientProvider` — so `useQueryClient()` is not available to it.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
})
